import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={12} cy={12} r={8.556} fill="#000" fillOpacity={0.8} />
      <Path
        d="M12 11.222a2.721 2.721 0 100-5.444 2.721 2.721 0 100 5.444zm0 .972c-1.818 0-5.445.912-5.445 2.722v.681c0 .374.476.905 1.167 1.458.69.553 1.944 1.556 4.277 1.556 2.334 0 4.079-1.356 4.278-1.556.2-.2 1.167-1.084 1.167-1.458v-.68c0-1.81-3.627-2.723-5.444-2.723z"
        fill="#fff"
      />
      <Path
        d="M1.611 5.889A.611.611 0 011 5.278V1h4.278a.611.611 0 010 1.222H2.222v3.056a.611.611 0 01-.61.61zM1.611 18.111a.611.611 0 00-.611.611V23h4.278a.611.611 0 000-1.222H2.222v-3.056a.611.611 0 00-.61-.61zM22.389 5.889A.611.611 0 0023 5.278V1h-4.278a.611.611 0 000 1.222h3.056v3.056c0 .337.273.61.61.61zM22.389 18.111c.337 0 .611.274.611.611V23h-4.278a.611.611 0 010-1.222h3.056v-3.056c0-.337.273-.61.61-.61z"
        fill="#2E2E2E"
      />
    </Svg>
  );
}

export default SvgComponent;
